// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"3e50761b","463":"aee7f938","923":"ff4f750f"}[chunkId] + ".chunk.js";
};